import { NodeFactory } from './../../../../../services/factories/node.factory';
import { WorkspaceService } from '../../../../../services/workspace.service';
import { DashboardHelper } from '../../../../../services/dashboard.service';
import { IWorkspaceInstanceModel } from '../../../../../models/workspace/workspace-instance.model';
import { Component, ElementRef, ViewChild, OnDestroy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WorkspaceStore } from '../../../../../services/stores/workspace.store';
import { BaseComponent } from '../../../../../components/base/base.component';
import { MaterialModule } from '../../../../../modules/catch-core/third-party/material/material.module';
@Component({
  selector: 'app-workspace-root-property',
  templateUrl: './workspace-root-property.component.html',
  styleUrls: ['./workspace-root-property.component.css'],
  standalone: false,
})
export class WorkspaceRootPropertyComponent extends BaseComponent implements OnDestroy, AfterViewInit {
  selectedWorkspace: IWorkspaceInstanceModel = {} as IWorkspaceInstanceModel;
  oldName: string = '';
  @ViewChild('inputName') inputNameElement!: ElementRef;
  public subscribers: any = {};
  myForm: FormGroup;
  locked: boolean = false;
  public isBacklogMap = false;
  private _wasRightPanelVisible: boolean = false;

  constructor(
    private dashboardHelper: DashboardHelper,
    private workspaceStore: WorkspaceStore,
    private workspaceService: WorkspaceService,
    private nodeFactory: NodeFactory,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
  ) {
    super();
    // console.log('WorkspaceRootPropertyComponent: constructor');
    this.myForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(255)]],
      description: '',
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // Reset the form value if panel is hidden
      this.subscribers.rightPanel = this.dashboardHelper.$showRightPanel.subscribe((show) => {
        if (this.selectedWorkspace) {
          this.myForm.controls.name.setValue(this.selectedWorkspace.name);
          this.myForm.controls.description.setValue(this.selectedWorkspace.description);
          // Only focus the name field when the panel is freshly opening (ZOO-9298).
          if (!this._wasRightPanelVisible && show) {
            this.setNameFieldAsFocus();
          }
          this._wasRightPanelVisible = show;
        }
      });

      this.subscribers.wsi = this.workspaceStore.$selectedWorkspaceInstance.subscribe((wsi) => {
        if (wsi) {
          const isFirstLoad = !this.selectedWorkspace?.id;
          this.selectedWorkspace = wsi;
          if (this.selectedWorkspace.isBacklog === true) {
            this.isBacklogMap = true;
            this.myForm.controls.description.setValue(
              'Backlog is a system generated read only label. It contains the latest status of all nodes created in the project. This Backlog label cannot be changed or deleted',
            );
          } else {
            this.isBacklogMap = false;
            this.myForm.controls.description.setValue(this.selectedWorkspace.description);
          }
          this.myForm.controls.name.setValue(this.selectedWorkspace.name);
          this.oldName = this.selectedWorkspace.name;
          // Only focus on initial load, not on every subsequent workspace update (ZOO-9298).
          if (isFirstLoad) {
            this.setNameFieldAsFocus();
          }
          this.locked = wsi.locked ? wsi.locked : false;
          this.cdr.detectChanges();
        }
      });
    });
  }

  ngOnDestroy() {
    if (this.subscribers) {
      if (this.subscribers.wsi) {
        this.subscribers.wsi.unsubscribe();
      }
      if (this.subscribers.rightPanel) {
        this.subscribers.rightPanel.unsubscribe();
      }
    }
    this.cdr.detach();
  }

  private setNameFieldAsFocus(): void {
    setTimeout(() => {
      if (this.inputNameElement) {
        this.inputNameElement.nativeElement.focus();
      }
    }, 0);
  }

  public selectName() {
    const value = this.inputNameElement?.nativeElement?.value?.toLowerCase() ?? '';
    if (value.startsWith('workspaceinstance')) {
      this.inputNameElement?.nativeElement?.select();
    }
  }

  public onDescriptionValueChange(value: string): void {
    const control = this.myForm?.controls?.description;
    if (!control) {
      return;
    }
    control.setValue(value);
    control.markAsDirty();
  }

  public onChange() {
    if (this.selectedWorkspace.name === '') {
      return;
    }
    this.dashboardHelper.setModifiedPropertyItem({
      id: this.selectedWorkspace.id,
      name: this.selectedWorkspace.name,
    });
  }

  public saveWork() {
    // console.log('saving workspaceinstance...' + this.selectedWorkspace.id);
    this.selectedWorkspace.name = this.myForm.value.name;
    this.selectedWorkspace.description = this.myForm.value.description;

    // this.uiStateStore.startBackendAction('Saving Workspace...');
    this.workspaceStore.$patchWSIRoot(this.nodeFactory.createPatchWSIRootPayloadFromWorkspaceModel(this.selectedWorkspace)).subscribe(
      (result) => {
        if (result) {
          // #TODO replace the message from resources
          // this.uiStateStore.endBackendAction('Workspace Saved!');
          this.myForm.markAsPristine();
          this.workspaceService.setModifyNodeToolTip({
            nodeId: this.selectedWorkspace.id,
            description: this.selectedWorkspace.description,
          });
          this.dashboardHelper.setModifiedPropertyItem({
            id: this.selectedWorkspace.id,
            name: this.selectedWorkspace.name,
          });
          this.oldName = this.selectedWorkspace.name;
          // this.projectStore.loadProject();
        }
      },
      (error) => {},
    );

    // this.uiHelper.closeRightPanel(this.router);
  }

  public onNameBlur() {
    if (this.selectedWorkspace.name === '') {
      this.selectedWorkspace.name = this.oldName; // revert to old name
      this.dashboardHelper.setModifiedPropertyItem({
        // update the diagram
        id: this.selectedWorkspace.id,
        name: this.selectedWorkspace.name,
      });
    } else {
      this.oldName = this.selectedWorkspace.name;
    }
  }
}
